import React, { useState } from "react";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Mughallogo from "../assets/Mughallogo.jfif";
import axios from "../Axios/Axios";
import Swal from "sweetalert2"; // SweetAlert2
import "bootstrap/dist/css/bootstrap.min.css";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!email || !password) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please enter both email and password.",
      });
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("/api/admin/login", {
        username: email,
        password: password,
      });

      localStorage.setItem("mughalsLoggedIn", response.data.token);

      Swal.fire({
        icon: "success",
        title: "Login Successful",
        showConfirmButton: false,
        timer: 1500,
      });

      onLogin();
      navigate("/home");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: "Please check your credentials.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container row w-100 m-3">
        <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center login-logo-bg">
          <img
            src={Mughallogo}
            alt="Logo"
            className="img-fluid login-logo"
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        </div>
        <div className="col-md-6 p-5 d-flex flex-column justify-content-center login-form">
          <h2 className="text-center fw-bold mb-4 login-title">Welcome MBS</h2>

          <div className="form-group mb-4">
            <label className="form-label fw-semibold login-label">Email</label>
            <input
              type="email"
              className=" login-inputs"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group mb-4">
            <label className="form-label fw-semibold login-label">
              Password
            </label>
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className=" login-inputs"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="position-absolute end-0 me-3 top-50 translate-middle-y login-eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <button
            onClick={handleLogin}
            className=" fw-bold text-white login-button"
            disabled={loading}
          >
            {loading ? "Please Wait..." : "Login"}
          </button>
        </div>
      </div>
    </div>
  );
}
